<template>
  <div v-if="loading">
    <div class=" d-flex flex-column">
      <div class="d-flex align-center ">
        <h5 class="rotate-text">
          Template
        </h5>
        <div class="left-side">
          <v-skeleton-loader
            class="skeleton-position"
            width="210px"
            height="20px"
            type="list-item, list-item "
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="ml-5"
            width="585px"
            height="80px"
            type="list-item, heading, heading, heading, list-item, list-item, list-item "
          ></v-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Skeletonloader",

  props: {
    loading: {
      type: Boolean
    }
  }
};
</script>
<style scoped>
.left-side {
  border-left: 1px solid #666666;
  margin-left: 19px;
  height: 100%;
}
.rotate-text {
  writing-mode: vertical-rl;
  text-orientation: sideways-right;
  transform: rotate(180deg);
  padding-top: 10px;
  text-align: left;
  font: normal normal normal 14px Roboto;
  letter-spacing: 0.11px;
  color: #666666;
  opacity: 1;
}
.v-skeleton-loader {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  background: #dcdcdc;
  padding-left: 10px;
  position: relative;
  margin-left: 10px;
}
.v-skeleton-loader.v-skeleton-loader--is-loading
  >>> .v-skeleton-loader__card-heading {
  background: #dcdcdc;
  display: flex;
  flex-direction: row;
  position: relative;
}
.v-skeleton-loader.v-skeleton-loader--is-loading
  >>> .v-skeleton-loader__heading {
  height: 50px;
  width: 120px;
  margin-right: 5px;
  background: #b9b9b9;
}
.v-skeleton-loader.v-skeleton-loader--is-loading
  >>> .v-skeleton-loader__list-item:last-child {
  position: absolute;
  top: 27px;
  left: 3px;
  height: 10px;
  width: 110px;
  background: none;
}
.v-skeleton-loader.v-skeleton-loader--is-loading
  >>> .v-skeleton-loader__list-item:nth-last-child(2) {
  position: absolute;
  top: 27px;
  left: 130px;
  height: 10px;
  width: 110px;
  background: none;
}
.v-skeleton-loader.v-skeleton-loader--is-loading
  >>> .v-skeleton-loader__list-item:nth-last-child(3) {
  position: absolute;
  top: 27px;
  left: 254px;
  height: 10px;
  width: 110px;
  background: none;
}
.v-skeleton-loader.v-skeleton-loader--is-loading
  >>> .v-skeleton-loader__list-item:nth-child(1) {
  position: fixed;
  top: -10px;
  left: 254px;
  height: 10px;

  width: 110px;
  background: none;
}

.v-skeleton-loader.v-skeleton-loader--is-loading >>> .v-skeleton-loader__text {
  background: #ffffff;
}
.v-skeleton-loader.v-skeleton-loader--is-loading
  >>> .v-skeleton-loader__heading.v-skeleton-loader__bone {
  display: flex;
  flex-direction: row;
}
.skeleton-position {
  margin-left: 40px;
  margin-bottom: -2px;
}
.v-skeleton-loader.skeleton-position
  >>> .v-skeleton-loader__list-item:last-child {
  background: white;
  position: absolute;
  width: 78px;
  height: 10px;
  top: 5px;
  left: 10px;
}
.v-skeleton-loader.skeleton-position
  >>> .v-skeleton-loader__list-item:nth-last-child(2) {
  background: white;
  position: absolute;
  width: 70px;
  height: 10px;
  top: 5px;
  left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/_Organisms/SkeletonLoader.vue